document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header-wrapper');
  const banner = document.querySelector('.banner, .slideshow');

  if (!header) return;

  function getThreshold() {
    // 如果首页是 Slideshow 就优先读取 Slideshow
    const target = document.querySelector('.slideshow') || document.querySelector('.banner');
    return target ? target.offsetHeight - header.offsetHeight : 80;
  }

  let threshold = getThreshold();

  function onScroll() {
    const y = window.scrollY;
    if (y > threshold) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }

  window.addEventListener('scroll', onScroll);
  window.addEventListener('resize', () => (threshold = getThreshold()));

  onScroll();
});
